<template>
  <b-card no-body
    class="p-2 bg-light border"
  >
    <b-row align-h="end" no-gutters>
      <b-col cols="12" md="" align-self="center">
        <div class="focuskpi--title">
          <img :src="getImage()" alt="">
          <h3 v-if="!onlyLogo">{{$t('Webportal.CX.Dashboard.Topbar.' + name)}}</h3>
        </div>
      </b-col>
      <b-col cols="6" md="auto">
        <center>
        {{ $t("Webportal.CX.Dashboard.Topbar.Current") }}
        <div class="border" :style="{ background: getBackground() }">
          <template v-if="type=='percentage'">
              <span v-if="!isNaN(value)">{{value}}%</span>
              <span v-if="isNaN(value)">{{this.$t('Webportal.CX.Dashboard.Exploration.NoData')}}</span>
          </template>
          <template v-if="type=='star'">
              {{value}} {{$t('Webportal.CX.Dashboard.Topbar.Stars')}}
          </template>
          <template v-if="type=='time'">
            <FormatKpiValue :kpi="{QuestionResult: value.toFixed(0)}" :format="2"/>
          </template>
          <template v-if="type=='default'">
              {{value}}
          </template>
        </div>
        </center>
      </b-col>
      <b-col cols="6" md="auto">
        <center>
        {{ $t("Webportal.CX.Dashboard.Topbar.Target") }}
        <div class="border">
          <template v-if="type=='percentage'">
            {{threshold}}%
          </template>
          <template v-if="type=='star'">
            {{threshold}} {{$t('Webportal.CX.Dashboard.Topbar.Stars')}}
          </template>
          <template v-if="type=='time'">
            <FormatKpiValue :kpi="{QuestionResult: threshold.toFixed(0)}" :format="2" />
          </template>
          <template v-if="type=='default'">
            {{threshold}}
          </template>
        </div>
        </center>
      </b-col>
      <b-col 
        cols="6" 
        md="auto" 
        v-if="
          $te(`Webportal.CX.Dashboard.Topbar.${name.replace(/\s/g,'')}`) &&
          $te(`Webportal.CX.Dashboard.Topbar.${name.replace(/\s/g,'')}.Text`)
        ">
        <font-awesome-icon  id="ExplainTopbarElement"
          class="clickable"
          :icon="['far', 'question-circle']"
          @click="showHelpPopup=!showHelpPopup" />
        
      </b-col>
    </b-row>
    <GenericHelpPopup 
      :title="$t(`Webportal.CX.Dashboard.Topbar.${name.replace(/\s/g,'')}`)"
      v-if="showHelpPopup"
      @close="showHelpPopup=false"
      >
      <div v-html="$t(`Webportal.CX.Dashboard.Topbar.${name.replace(/\s/g,'')}.Text`)"></div>
    </GenericHelpPopup>
  </b-card>
</template>

<script>
import FormatKpiValue from "@/components/Shared/FormatKpiValue";
import GenericHelpPopup from "@/components/Shared/GenericHelpPopup";

export default {
  components: {
    FormatKpiValue,
    GenericHelpPopup
  },
  props: {
    name: String,
    value: Number,
    threshold: Number,
    onlyLogo: Boolean,
    colorRange: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      default: 'percentage' // 'star', 'time'
    }
  },
  data() {
    return {
      showHelpPopup: false
    }
  },
  methods: {
    getBackground() {
      if (
          ((this.value < this.threshold && this.type != 'time') ||  // less is worse iff type != 'time'
           (this.value > this.threshold && this.type == 'time')) && // less is better iff type == 'time'
          this.colorRange.find(c => c.Maximum == 69.99) || isNaN(this.value)) {
        return this.colorRange.find(c => c.Maximum == 69.99).Color
      } else if (this.colorRange.find(c => c.Maximum == 100)){
        return this.colorRange.find(c => c.Maximum == 100).Color
      } else {
        return 'transparent';
      }
    },
    getImage() {
      switch(this.name) {
        case "google": 
          return "/static/img/focus-kpis/google.svg";
        case "average_seobility":
          return "/static/img/focus-kpis/seobility.png";
        case "ncuc_visualpresentation":
          return "/static/img/focus-kpis/visual_presentation.svg";
        case "average_responsetime":
          return "/static/img/focus-kpis/response_time.svg";
        case "firstaidkits":
          return "/static/img/focus-kpis/firstaidkits.svg";
      }
      
    }
  }
}
</script>

<style scoped>

  h3 {
    font-size: 0.9rem;
    margin: 0;
    font-weight: normal;
  }

  img {
    max-height: 2rem;
  }

  center {
    margin-left: 0.5rem;
  }

  center div{
    padding: 0.1rem 0.5rem;
    min-width: 4rem;
  }

  .bi-star-fill {
    color: yellow;
  }

  .card{
    border: none;
    min-width: 100px;
  }

  .focuskpi--title {
    vertical-align: middle;
    text-align: center;
  }
  .focuskpi--title img {
    display: block;
    margin: 0 auto;
  }
  #ExplainTopbarElement {
    color: rgb(100, 100, 100);
    transform: translate(3px, -3px);
  }
</style>